"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Sidebar = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Sidebar = exports.Sidebar = _styledComponents["default"].div.withConfig({
  displayName: "Sidebar",
  componentId: "sc-6utsg5-0"
})(["@media (min-width:", "){position:fixed;block-size:100%;top:0;inline-size:", ";left:0;z-index:", ";[dir='rtl'] &{left:unset;right:0;}}.docs-story &{position:relative;@media (min-width:", "){position:absolute;}}"], _encoreFoundation.screenSmMin, function (props) {
  return props.$sidebarWidth || _index.sidebarBaseWidth;
}, _index.zIndexFixed, _encoreFoundation.screenSmMin);
var _default = exports["default"] = Sidebar;